<h2 mat-dialog-title class="dialog-header">
    <mat-icon class="mr-2 entity-security-groups">security</mat-icon>
    {{ securityGroup?.name || 'Security Group Details' }}

    <button mat-icon-button mat-dialog-close class="close-button">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content class="security-group-details-content">
    <div class="security-group-details-layout" *ngIf="securityGroup">
        <!-- Left Sidebar -->
        <aside class="security-group-sidebar">
            <button
                mat-icon-button
                *ngIf="orgDialogService.mayManageSecurityGroups"
                class="sidebar-edit-button"
                (click)="openEditDialog()"
                matTooltip="Edit Security Group"
            >
                <mat-icon>edit</mat-icon>
            </button>
            <div class="security-group-avatar-section">
                <div class="security-group-avatar">
                    <mat-icon class="avatar-icon">security</mat-icon>
                </div>
                <h3 class="security-group-name" [matTooltip]="securityGroup.description || ''">
                    {{ securityGroup.name | titlecase }}
                </h3>
                <p *ngIf="securityGroup.description" class="security-group-description">
                    {{ securityGroup.description }}
                </p>
            </div>

            <mat-divider></mat-divider>

            <div class="security-group-quick-stats">
                <div class="stat-row">
                    <mat-icon>star</mat-icon>
                    <span class="stat-label"
                        >{{ features.length }} {{ features.length === 1 ? 'FEATURE' : 'FEATURES' }}</span
                    >
                </div>
                <div class="stat-row">
                    <mat-icon>vpn_key</mat-icon>
                    <span class="stat-label"
                        >{{ getTotalPermissionsCount() }} {{ getTotalPermissionsCount() === 1 ? 'PERMISSION' :
                        'PERMISSIONS' }}</span
                    >
                </div>
                <div class="stat-row">
                    <mat-icon>school</mat-icon>
                    <span class="stat-label"
                        >{{ hatsUsingGroup.length }} {{ hatsUsingGroup.length === 1 ? 'HAT' : 'HATS' }}</span
                    >
                </div>
                <div class="stat-row">
                    <mat-icon>person</mat-icon>
                    <span class="stat-label"
                        >{{ usersViaHats.length }} {{ usersViaHats.length === 1 ? 'USER' : 'USERS' }}</span
                    >
                </div>
            </div>
        </aside>

        <!-- Main Content -->
        <main class="security-group-main-content">
            <mat-accordion class="sections-accordion" multi>
                <!-- Hats Using This Group -->
                <mat-expansion-panel [expanded]="sectionStates.hats" (expandedChange)="sectionStates.hats = $event">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="entity-hats">school</mat-icon>
                            Hats Using This Group ({{ hatsUsingGroup.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div *ngIf="hatsUsingGroup.length > 0" class="hats-list">
                        <div *ngFor="let hat of hatsUsingGroup" class="hat-item">
                            <div class="hat-avatar">
                                <mat-icon>school</mat-icon>
                            </div>
                            <div class="hat-info">
                                <span class="hat-name">{{ hat.name | titlecase }}</span>
                                <span class="ng-hat-location" *ngIf="(hat | hatLocation: data.organization) as hatWhere"
                                    >{{ hatWhere }}</span
                                >
                                <span class="hat-users">{{ hat.userCount }} user(s)</span>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="hatsUsingGroup.length === 0" class="empty-section">
                        <span>No hats are using this security group</span>
                    </div>
                </mat-expansion-panel>

                <!-- Users Via Hats -->
                <mat-expansion-panel [expanded]="sectionStates.users" (expandedChange)="sectionStates.users = $event">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="entity-users">people</mat-icon>
                            Users (via Hats) ({{ usersViaHats.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div *ngIf="usersViaHats.length > 0" class="users-list">
                        <div *ngFor="let user of usersViaHats" class="user-item">
                            <div
                                class="user-avatar"
                                [style.background-image]="'url(' + getUserAvatarUrl(user) + ')'"
                                style="background-size: cover; background-position: center"
                            ></div>
                            <div class="user-info">
                                <span class="user-name">{{ user.name }}</span>
                                <span class="user-hat">via {{ user.hatName }}</span>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="usersViaHats.length === 0" class="empty-section">
                        <span>No staff have access through this security group</span>
                    </div>
                </mat-expansion-panel>

                <!-- Features & Permissions -->
                <mat-expansion-panel
                    [expanded]="sectionStates.features"
                    (expandedChange)="sectionStates.features = $event"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="entity-features">star</mat-icon>
                            Features & Permissions ({{ features.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-accordion *ngIf="features.length > 0" class="features-accordion">
                        <mat-expansion-panel *ngFor="let feature of features">
                            <mat-expansion-panel-header>
                                <mat-panel-title [matTooltip]="feature.description || ''">
                                    <mat-icon class="feature-icon" [class.disabled]="!feature.enabled">
                                        {{ feature.enabled ? 'check_circle' : 'cancel' }}
                                    </mat-icon>
                                    {{ feature.name | titlecase }}
                                </mat-panel-title>
                                <mat-panel-description>
                                    {{ feature.permissions.length }} permission(s)
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <div class="permissions-list" *ngIf="feature.permissions.length > 0">
                                <mat-chip-set class="entity-permissions-chips">
                                    <mat-chip
                                        *ngFor="let permission of feature.permissions"
                                        class="permission-chip"
                                        [matTooltip]="feature.permissionDescriptions?.[permission] || ''"
                                    >
                                        <mat-icon matChipAvatar>vpn_key</mat-icon>
                                        {{ permission | normalize }}
                                    </mat-chip>
                                </mat-chip-set>
                            </div>

                            <div *ngIf="feature.permissions.length === 0" class="no-permissions">
                                <span>No specific permissions</span>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <div *ngIf="features.length === 0" class="empty-section">
                        <span>No features assigned to this security group</span>
                    </div>
                </mat-expansion-panel>

                <!-- Policies -->
                <mat-expansion-panel
                    [expanded]="sectionStates.policies"
                    (expandedChange)="sectionStates.policies = $event"
                    *ngIf="policies.length > 0"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="entity-policies">policy</mat-icon>
                            Policies ({{ policies.length }})
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-list class="policies-list">
                        <mat-list-item *ngFor="let policy of policies">
                            <mat-icon matListItemIcon>policy</mat-icon>
                            <span matListItemTitle>{{ policy }}</span>
                        </mat-list-item>
                    </mat-list>
                </mat-expansion-panel>

                <!-- Menu Preview Section -->
                <mat-expansion-panel
                    [expanded]="sectionStates.menuPreview"
                    (expandedChange)="sectionStates.menuPreview = $event"
                    *ngIf="menuPreview.length > 0"
                >
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon class="entity-security-groups">menu</mat-icon>
                            Menu Preview ({{ menuPreview.length }})
                            <span class="menu-preview-subtitle">(What Users in This Group Will See)</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="menu-preview">
                        <div *ngFor="let group of menuPreview" class="menu-group">
                            <div class="menu-group-header">{{ group.section }}</div>
                            <div class="menu-items">
                                <div *ngFor="let item of group.items" class="menu-item">
                                    <mat-icon>{{ item.icon }}</mat-icon>
                                    <span>{{ item.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </main>
    </div>

    <!-- No Data State -->
    <div *ngIf="!securityGroup" class="no-data-state">
        <mat-icon>error_outline</mat-icon>
        <p>Security group data not available</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
